var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortcutEditReservation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.25H16.875V6.75H10.5V42H37.5V30.375H39V43.5H9V5.25ZM21.75 6.75H19.5V5.25H21.75V6.75ZM28.5 6.75H25.7812V5.25H28.5V6.75ZM37.5 6.75H31.125V5.25H39V22.125H37.5V6.75Z",
    fill: "#0C2487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 8.25V5.25C18.75 4.83579 18.4142 4.5 18 4.5C17.5858 4.5 17.25 4.83579 17.25 5.25V8.25C17.25 8.66421 17.5858 9 18 9C18.4142 9 18.75 8.66421 18.75 8.25ZM18 3C16.7574 3 15.75 4.00736 15.75 5.25V8.25C15.75 9.49264 16.7574 10.5 18 10.5C19.2426 10.5 20.25 9.49264 20.25 8.25V5.25C20.25 4.00736 19.2426 3 18 3Z",
    fill: "#0C2487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 8.25V5.25C24.75 4.83579 24.4142 4.5 24 4.5C23.5858 4.5 23.25 4.83579 23.25 5.25V8.25C23.25 8.66421 23.5858 9 24 9C24.4142 9 24.75 8.66421 24.75 8.25ZM24 3C22.7574 3 21.75 4.00736 21.75 5.25V8.25C21.75 9.49264 22.7574 10.5 24 10.5C25.2426 10.5 26.25 9.49264 26.25 8.25V5.25C26.25 4.00736 25.2426 3 24 3Z",
    fill: "#0C2487"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.75 8.25V5.25C30.75 4.83579 30.4142 4.5 30 4.5C29.5858 4.5 29.25 4.83579 29.25 5.25V8.25C29.25 8.66421 29.5858 9 30 9C30.4142 9 30.75 8.66421 30.75 8.25ZM30 3C28.7574 3 27.75 4.00736 27.75 5.25V8.25C27.75 9.49264 28.7574 10.5 30 10.5C31.2426 10.5 32.25 9.49264 32.25 8.25V5.25C32.25 4.00736 31.2426 3 30 3Z",
    fill: "#0C2487"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 14.25H9.75V12.75H37.5V14.25Z",
    fill: "#0C2487"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.75 19.5H17.25V21.75H30.75V19.5ZM15.75 18V23.25H32.25V18H15.75Z",
    fill: "#0C2487"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 27H17.25V29.25H24V27ZM15.75 25.5V30.75H25.5V25.5H15.75Z",
    fill: "#0C2487"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9331 36.5304L42.7965 24.667C43.6333 23.8302 43.6333 22.4734 42.7965 21.6365C41.9596 20.7997 40.6029 20.7997 39.766 21.6365L27.9026 33.5L27.5238 36.9092L30.9331 36.5304ZM31.6217 37.9631L43.8571 25.7277C45.2798 24.305 45.2798 21.9985 43.8571 20.5759C42.4345 19.1533 40.128 19.1533 38.7054 20.5759L26.4699 32.8114L25.8259 38.6071L31.6217 37.9631Z",
    fill: "#0C2487"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9821 27.6015L37.2987 22.9181L38.3594 21.8574L43.0428 26.5409L41.9821 27.6015Z",
    fill: "#0C2487"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6235 36.6745L27.7597 32.8107L28.8203 31.75L32.6841 35.6138L31.6235 36.6745Z",
    fill: "#0C2487"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcutEditReservation);
export default __webpack_public_path__ + "static/media/shortcut_editReservation.81feff644cb22fae79072ea88b3d65b3.svg";
export { ForwardRef as ReactComponent };